var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h3", { staticClass: "title is-5 mt-6" }, [
      _vm._v(_vm._s(_vm.$t("term.drillProgress"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("label", { staticClass: "checkbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isMastered,
                expression: "isMastered",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.isMastered)
                ? _vm._i(_vm.isMastered, null) > -1
                : _vm.isMastered,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.isMastered,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isMastered = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isMastered = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isMastered = $$c
                  }
                },
                _vm.updateIsMastered,
              ],
            },
          }),
          _vm._v("\n        " + _vm._s(_vm.$t("term.isMastered")) + "\n      "),
        ]),
      ]),
      _vm._v(" "),
      _vm.errorIsMastered
        ? _c("p", { staticClass: "has-text-danger" }, [
            _vm._v("\n      " + _vm._s(_vm.errorIsMastered) + "\n    "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }